import { motion } from "framer-motion";
import { Instagram, Heart, ArrowUpRight } from "lucide-react";
import { fadeUp, stagger } from "./motion";
import { ASSETS, IG_HANDLE, IG_URL } from "../../data/site";

const POSTS = [
  ASSETS.mangonada, ASSETS.stylishStrawberry, ASSETS.shakesCups, ASSETS.mightyMatcha,
  ASSETS.gulaabJamun, ASSETS.faloodaFantasy, ASSETS.uniform, ASSETS.rasMalai,
];

export const InstagramFeed = () => {
  return (
    <section id="instagram" data-testid="instagram-section" className="relative bg-[#FFF7F0]">
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-20 sm:py-28">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-10">
          <div>
            <motion.span variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }}
              className="eyebrow text-[#12B99B]">Follow The Fun</motion.span>
            <motion.h2 variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={{ once: true }}
              className="font-display mt-3 text-[clamp(2rem,5vw,3.75rem)] leading-[1.02] text-[#2A1620]">
              On <span className="font-script text-[#F63C8B]">Instagram</span>
            </motion.h2>
            <motion.a variants={fadeUp} custom={2} initial="hidden" whileInView="show" viewport={{ once: true }}
              href={IG_URL} target="_blank" rel="noopener noreferrer" data-testid="ig-handle"
              className="mt-3 inline-flex items-center gap-2 text-[#F63C8B] font-semibold link-underline">
              @{IG_HANDLE}
            </motion.a>
          </div>
          <motion.a variants={fadeUp} custom={2} initial="hidden" whileInView="show" viewport={{ once: true }}
            href={IG_URL} target="_blank" rel="noopener noreferrer" data-testid="ig-follow"
            className="btn-primary inline-flex items-center gap-2 px-8 py-4 text-sm font-bold uppercase tracking-[0.12em] self-start">
            <Instagram size={18} /> Follow Us
          </motion.a>
        </div>

        <motion.div variants={stagger} initial="hidden" whileInView="show" viewport={{ once: true }}
          className="grid grid-cols-2 sm:grid-cols-4 gap-3 sm:gap-4">
          {POSTS.map((src, i) => (
            <motion.a key={i} variants={fadeUp} href={IG_URL} target="_blank" rel="noopener noreferrer"
              data-testid={`ig-post-${i}`}
              className="group relative overflow-hidden rounded-3xl border-4 border-white shadow-[0_20px_40px_-24px_rgba(246,60,139,0.5)] aspect-square">
              <img src={src} alt={`@${IG_HANDLE} on Instagram`} loading="lazy"
                className="w-full h-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-110" />
              <div className="absolute inset-0 bg-[#F63C8B]/0 group-hover:bg-[#F63C8B]/55 transition-colors duration-400 flex items-center justify-center">
                <Instagram size={30} className="text-white opacity-0 group-hover:opacity-100 transition-opacity duration-400" strokeWidth={2} />
              </div>
              <span className="absolute top-2.5 right-2.5 grid place-items-center h-8 w-8 rounded-full bg-white/90 opacity-0 group-hover:opacity-100 transition-opacity duration-400">
                <ArrowUpRight size={16} className="text-[#F63C8B]" />
              </span>
              <span className="absolute bottom-2.5 left-2.5 inline-flex items-center gap-1 text-white text-xs font-bold opacity-0 group-hover:opacity-100 transition-opacity duration-400">
                <Heart size={13} className="fill-white" /> Like
              </span>
            </motion.a>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
